<script lang="ts">
    import type { Readable } from "svelte/store";
    import Woka from "../../Woka/Woka.svelte";
    import Spinner from "../../Icons/Spinner.svelte";

    interface Props {
        pictureStore: Readable<string | undefined>;
        fallbackName: string;
        customWidth?: string;
    }

    let { pictureStore, fallbackName, customWidth = "36px" }: Props = $props();

    function getInitial(name: string): string {
        return name.trim().charAt(0).toUpperCase() || "?";
    }
</script>

{#if $pictureStore !== undefined}
    {#if $pictureStore}
        <Woka src={$pictureStore} {customWidth} />
    {:else}
        <span class="text-mdark font-semibold text-sm">{getInitial(fallbackName)}</span>
    {/if}
{:else}
    <div class="flex items-center justify-center w-8 h-8" aria-label="Loading avatar">
        <Spinner size="sm" fillColor="fill-white" />
    </div>
{/if}
